package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.backend.setDoc
import org.lennycodes.hldi.data.Event
import kotlin.collections.isNotEmpty
import kotlin.text.isBlank
import kotlin.text.isNotEmpty

@Composable
fun AddEventDialog(
    onDismiss: () -> Unit,
    onSuccess: () -> Unit
) {

    val scope = rememberCoroutineScope()

    var isLoading by remember { mutableStateOf(false) }

    var title by remember { mutableStateOf("") }
    var date by remember { mutableStateOf("") }
    var location by remember { mutableStateOf("") }
    var description by remember { mutableStateOf("") }
    var registrationUrl by remember { mutableStateOf("") }

    var errorMessage by remember { mutableStateOf("") }


    Div(
        attrs = Modifier
            .padding(16.px)
            .then(DialogBackdropStyle.toModifier())
            .toAttrs {

                onClick {
                    if (!isLoading) {
                        onDismiss()
                    }
                }

            }
    ) {


        Div(
            attrs = Modifier
                .padding(32.px)
                .then(DialogCardStyle.toModifier())
                .toAttrs {

                    onClick {
                        it.stopPropagation()
                    }

                }
        ) {


            H3(
                attrs = DialogTitleStyle.toAttrs()
            ) {
                Text("New Event")
            }


            P(
                attrs = DialogSubtitleStyle.toAttrs()
            ) {
                Text("Create an upcoming event.")
            }


            EventField(
                label = "Title",
                value = title,
                placeholder = "Community Awareness Workshop",
                isLoading = isLoading,
                onValueChange = { title = it }
            )


            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Date")
                }


                Input(
                    type = InputType.Date,
                    attrs = Modifier
                        .padding(11.px,14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            placeholder("2026-08-20")

                            value(date)

                            onInput {
                                date = it.value
                            }


                            if(isLoading){
                                disabled()
                            }

                        }
                )

            }


            EventField(
                label = "Location",
                value = location,
                placeholder = "Biharamulo District",
                isLoading = isLoading,
                onValueChange = { location = it }
            )


            EventField(
                label = "Registration URL (Optional)",
                value = registrationUrl,
                placeholder = "https://example.com/register",
                isLoading = isLoading,
                onValueChange = { registrationUrl = it }
            )


            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Description")
                }


                TextArea(
                    value = description,

                    attrs = Modifier
                        .padding(11.px,14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            placeholder(
                                "Describe the event"
                            )


                            onInput {

                                description = it.value

                            }


                            if(isLoading){
                                disabled()
                            }

                        }
                )

            }



            if(errorMessage.isNotEmpty()) {

                P(
                    attrs = Modifier
                        .color(Color.rgb(220,53,69))
                        .fontSize(14.px)
                        .margin(0.px,0.px,16.px)
                        .toAttrs()
                ) {

                    Text(errorMessage)

                }

            }



            Row(
                modifier = DialogActionsRowStyle.toModifier(),

                horizontalArrangement = Arrangement.spacedBy(12.px)
            ) {


                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px,22.px)
                        .then(CancelButtonStyle.toModifier()),

                    onClick = {

                        onDismiss()

                    }

                ){

                    Text("Cancel")

                }



                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px,22.px)
                        .then(SaveButtonStyle.toModifier()),


                    onClick = {

                        scope.launch {


                            try {

                                errorMessage = ""


                                if(title.isBlank()) {

                                    errorMessage = "Event title is required"
                                    return@launch

                                }


                                if(date.isBlank()) {

                                    errorMessage = "Event date is required"
                                    return@launch

                                }


                                if(location.isBlank()) {

                                    errorMessage = "Event location is required"
                                    return@launch

                                }


                                if(description.isBlank()) {

                                    errorMessage = "Event description is required"
                                    return@launch

                                }



                                isLoading = true



                                val eventCollection = collection(
                                    FirebaseService.db,
                                    "events"
                                )

                                val generatedId =
                                    generateFirebaseId()


                                val eventDocument = doc(
                                    eventCollection,
                                    generatedId
                                )


                                val eventId = eventDocument.id



                                val event = Event(
                                    id = eventId,
                                    title = title,
                                    date = date,
                                    location = location,
                                    description = description,
                                    registrationUrl = registrationUrl
                                )



                                setDoc(
                                    eventDocument,
                                    event.toFirebaseData()
                                ).await()



                                console.log(
                                    "Event saved successfully"
                                )


                                onSuccess()

                                onDismiss()



                            } catch(e: Throwable) {


                                console.error(
                                    "Saving event failed: ${e.message}"
                                )


                                errorMessage =
                                    e.message ?: "Something went wrong"


                            } finally {

                                isLoading = false

                            }

                        }

                    }

                ){

                    Text(
                        if(isLoading)
                            "Saving..."
                        else
                            "Save"
                    )

                }

            }

        }

    }

}
@Composable
private fun EventField(
    label: String,
    value: String,
    placeholder: String,
    isLoading: Boolean,
    onValueChange: (String) -> Unit
) {

    Div(attrs = FieldGroupStyle.toAttrs()) {

        Label(
            attrs = FieldLabelStyle.toAttrs()
        ) {

            Text(label)

        }


        Input(
            type = InputType.Text,

            attrs = Modifier
                .padding(11.px,14.px)
                .then(FieldInputStyle.toModifier())
                .toAttrs {

                    this.placeholder(placeholder)

                    this.value(value)

                    onInput {

                        onValueChange(it.value)

                    }


                    if(isLoading) {
                        disabled()
                    }

                }
        )

    }
}